<script>
  import { _ } from "svelte-i18n";
  let showDetails = false;
  function toggle() {
    showDetails = !showDetails;
  }

  import Radio from "./Radio.svelte";
  export let mental = "";
  export let physical;
</script>

<div class="form-section form-section--paddingless">
  <!-- English on norwegian version, should be changed -->
  <h3>
    <button
      on:click={toggle}
      type="button"
      class="button-text button-text--chevron-down {showDetails
        ? 'is-toggled'
        : ''}">{$_("dayParameters.form.readiness.title")}</button
    >
  </h3>
  <div class={showDetails ? "" : "radio-group--default-hide"}>
    <h4 class="">{$_("dayParameters.form.readiness.physical")}</h4>
    <div>
      <div class="radio-group__labels false">
        <span class="radio-group__label radio-group__label--left"
          >{$_("dayParameters.form.readiness.low")}</span
        ><span class="radio-group__label" />
        <span class="radio-group__label radio-group__label--right"
          >{$_("dayParameters.form.readiness.high")}</span
        >
      </div>
      <div class="radio-group radio-group--1-10">
        {#each { length: 10 } as _, index}
          <Radio bind:group={physical} value={index + 1} label="Fysisk klar" />
        {/each}
      </div>
    </div>

    <h4 class="">{$_("dayParameters.form.readiness.mental")}</h4>
    <div>
      <div class="radio-group__labels false">
        <span class="radio-group__label radio-group__label--left"
          >{$_("dayParameters.form.readiness.low")}</span
        ><span class="radio-group__label" />
        <span class="radio-group__label radio-group__label--right"
          >{$_("dayParameters.form.readiness.high")}</span
        >
      </div>

      <div class="radio-group radio-group--1-10">
        {#each { length: 10 } as _, index}
          <Radio bind:group={mental} value={index + 1} label="Mentalt klar" />
        {/each}
      </div>
    </div>
  </div>
</div>
